import React, { useState } from 'react';
import { Row } from 'react-bootstrap';
import { Switch } from '../../../../../components/atoms';

const Feature = props => {
    const [ features, setFeatures ] = useState({
        parking:false,
        tolls:false
    });

    const onChangeFeature = (type) => {
        setFeatures({
            ...features, 
            [type]:!features[type]
        })
        props.onChange({
            ...features, 
            [type]:!features[type],
            courier:'deliveree',
            service:props.service
        })
    }

    return (
        <div className="card px-4">
            <div className="justify-content-between align-items-center d-flex py-1">
                <div>
                    Biaya Parkir <b>(Tambahan biaya diakhir)</b>
                </div>
                <Switch 
                    id={'parking'}
                    onChange={() => onChangeFeature('parking')}
                    checked={features.parking}
                />
            </div>
            <div className="justify-content-between align-items-center d-flex py-1">
                <div>
                    Biaya Toll <b>(Tambahan biaya diakhir)</b>
                </div>
                <Switch 
                    id={'tolls'}
                    onChange={() => onChangeFeature('tolls')}
                    checked={features.tolls}
                />
            </div>
        </div>
    )
}

export default Feature;